import { z } from "zod";
import { assistantContextSchema } from "./assistant-protocol";
import { assistantCodegenJobListSchema } from "./assistant-codegen-job";
import { codegenHttpSummarySchema } from "./assistant-codegen-http";

/** The original native job canonical bytes, shared without changing the
 * server hash algorithm or rewriting any native input. */
export function codegenJobCanonicalText(value: unknown) {
  function canonical(v: unknown): unknown {
    if (Array.isArray(v)) return v.map(canonical);
    if (v && typeof v === "object") return Object.fromEntries(
      Object.entries(v).sort(([a], [b]) => a < b ? -1 : a > b ? 1 : 0)
        .map(([k, x]) => [k, canonical(x)])
    );
    return v;
  }
  return JSON.stringify(canonical(value));
}
export const nativeCodegenLifecycleTools = [
  "prepare_native_codegen", "execute_prepared_native_codegen",
  "read_native_codegen_job", "cancel_native_codegen_job", "recover_owned_native_codegen_jobs",
] as const;
export type NativeCodegenLifecycleTool = typeof nativeCodegenLifecycleTools[number];
export const nativeCodegenReadTools = [
  "read_native_codegen_context", "read_native_codegen_manifest", "read_native_codegen_file", "read_native_codegen_source",
] as const;
export type NativeCodegenReadTool = typeof nativeCodegenReadTools[number];
export const nativeCodegenContextOutputSchema = z.object({
  context: assistantContextSchema, contextDigest: z.string().regex(/^[a-f0-9]{64}$/),
}).strict();
export const nativeCodegenRecoveryInputSchema = z.object({}).strict();
export const nativeCodegenRecoveryOutputSchema = z.object({
  projectId: z.string().min(1), jobs: z.array(codegenHttpSummarySchema).max(128),
  inventory:z.object({complete:z.boolean(),scope:z.literal("current_native_context_and_cached_original_references"),context:assistantContextSchema}).strict(),
}).strict();
export const codegenHttpListSchema = z.object({
  context: assistantContextSchema, input: assistantCodegenJobListSchema,
}).strict();
export const codegenHttpListOutputSchema = z.array(codegenHttpSummarySchema).max(100);
